/**
 * Business Reviews Placeholder Component
 * 리뷰 시스템 Placeholder (추후 구현 예정)
 */

import { Card, CardContent } from "@/components/ui/card";
import { Star, MessageSquare } from "lucide-react";

export function BusinessReviewsPlaceholder() {
  return (
    <Card>
      <CardContent className="py-8 text-center">
        <div className="flex flex-col items-center gap-3">
          <div className="w-12 h-12 rounded-full bg-muted flex items-center justify-center">
            <MessageSquare className="w-6 h-6 text-muted-foreground" />
          </div>
          <div>
            <h3 className="font-semibold mb-1">리뷰 시스템</h3>
            <p className="text-sm text-muted-foreground">
              리뷰 기능은 추후 업데이트 예정입니다
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

